export const emailCommunicationDisclosure = {
  v1: (
    <p>
      By checking the checkbox, you hereby give your affirmative consent to provide payment and
      consumer rights notices required under{' '}
      <a
        href="https://www.consumerfinance.gov/rules-policy/regulations/1041/9/"
        rel="noreferrer noopener"
        target="_blank"
      >
        12 CFR § 1041
      </a>{' '}
      to you via email at the email address associated with your account with us. You may contact us
      by mail at 175 W. Jackson Blvd., Attn: NetCredit Customer Support Team, Suite 600, Chicago, IL
      60604, by phone at (877) 392-2014, or by email at support@netcredit.com to revoke consent to
      receive these disclosures via email. Note that we will not be able to email disclosures required
      by 12 CFR § 1041 if we receive notification that you are unable to receive emails at the email
      address associated with your account.
    </p>
  ),
} as const;
